import { Icon } from '@repo/ui';

import { ANIMATION_DELAY_200MS_STYLE } from '../../utils/attorney-response';

export const InvoiceNotFound = () => {
  return (
    <div
      className="flex-1 h-full flex flex-col items-center justify-center p-8 text-center opacity-0 animate-fade-in-up duration-200"
      style={ANIMATION_DELAY_200MS_STYLE}
    >
      {/* Animated Illustration Area */}
      <div className="relative mb-8 group">
        {/* Background decorative circles */}
        <div className="absolute inset-0 bg-xtnd-blue/10 dark:bg-xtnd-blue/5 rounded-full blur-3xl transform scale-150 animate-pulse" />
        <div className="relative flex items-center justify-center w-32 h-32">
          {/* Outer dashed ring */}
          <div className="absolute inset-0 border-2 border-dashed border-xtnd-blue/30 dark:border-xtnd-blue/20 rounded-full animate-[spin_10s_linear_infinite]" />
          {/* Main Icon Container */}
          <div className="relative flex items-center justify-center w-24 h-24 bg-xtnd-white dark:bg-xtnd-dark-800 rounded-2xl shadow-xl border border-gray-50 dark:border-xtnd-dark-700 transform group-hover:rotate-6 transition-transform duration-300">
            <Icon name="HiXCircle" size="lg" className="text-xtnd-blue dark:text-xtnd-blue-400" />
          </div>
          {/* Small floating element */}
          <div className="absolute -bottom-2 -right-2 bg-xtnd-blue text-xtnd-white p-2 rounded-lg shadow-lg animate-bounce">
            <Icon name="HiDocumentText" size="sm" />
          </div>
        </div>
      </div>

      {/* Typography */}
      <div className="space-y-3 mb-10">
        <h3 className="text-lg font-bold text-xtnd-dark dark:text-xtnd-light tracking-tight leading-tight">
          No results found
        </h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
          We couldn't find the appeal you're looking for. Please check the ID or try another search.
        </p>
      </div>
    </div>
  );
};

export const UnauthorizedAccess = () => {
  return (
    <div
      className="flex-1 h-full flex flex-col items-center justify-center p-8 text-center opacity-0 animate-fade-in-up duration-200"
      style={ANIMATION_DELAY_200MS_STYLE}
    >
      {/* Animated Illustration Area */}
      <div className="relative mb-8 group">
        {/* Background decorative circles */}
        <div className="absolute inset-0 bg-red-500/10 dark:bg-red-500/5 rounded-full blur-3xl transform scale-150 animate-pulse" />
        <div className="relative flex items-center justify-center w-32 h-32">
          {/* Outer dashed ring */}
          <div className="absolute inset-0 border-2 border-dashed border-red-500/30 dark:border-red-500/20 rounded-full animate-[spin_10s_linear_infinite]" />
          {/* Main Icon Container */}
          <div className="relative flex items-center justify-center w-24 h-24 bg-xtnd-white dark:bg-xtnd-dark-800 rounded-2xl shadow-xl border border-gray-50 dark:border-xtnd-dark-700 transform group-hover:rotate-6 transition-transform duration-300">
            <Icon name="HiLockClosed" size="lg" className="text-red-500 dark:text-red-400" />
          </div>
          {/* Small floating element */}
          <div className="absolute -bottom-2 -right-2 bg-red-500 text-xtnd-white p-2 rounded-lg shadow-lg animate-bounce">
            <Icon name="HiExclamationCircle" size="sm" />
          </div>
        </div>
      </div>

      {/* Typography */}
      <div className="space-y-3 mb-10">
        <h3 className="text-lg font-bold text-xtnd-dark dark:text-xtnd-light tracking-tight leading-tight">
          Access Denied
        </h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
          You are not authorized to edit this attorney response. Please contact your administrator
          if you believe this is an error.
        </p>
      </div>
    </div>
  );
};
